import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ScrollToTop from "./utils/ScrollToTop";

import MainLayout from "./components/layout/Layout";

import HomePage from "./pages/HomePage/HomePage";
import SellersPage from "./pages/SellersPage/SellersPage";
import TemplesPage from "./pages/TemplesPage/TemplesPage";
import HowItWorksPage from "./pages/HowItWorksPage/HowItWorksPage";
import ContactPage from "./pages/ContactPage/ContactPage";
import FAQPage from "./pages/FaqPage/FaqPage";
import SupportPage from "./pages/SupportPage/SupportPage";
import AboutPage from "./pages/AboutPage/AboutPage";
import SoW from "./pages/SoWPage/SoWPage";
import SoP from "./pages/SOPPage/SOPPage";
import SupportHandBook from "./pages/SupportHandbookPage/SupportHandbookPage";
import GetAppPage from "./pages/GetAppPage/GetAppPage";
import TermsConditions from "./pages/Privacy Policy/TermsConditions";
import PrivacyPolicy from "./pages/Privacy Policy/PrivacyPolicy";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";

import "./App.css";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route path="sellers" element={<SellersPage />} />
          <Route path="community" element={<TemplesPage />} />
          <Route path="how-it-works" element={<HowItWorksPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="faq" element={<FAQPage />} />
          <Route path="get-app" element={<GetAppPage />} />
          <Route path="support" element={<SupportPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="sow" element={<SoW />} />
          <Route path="support-handbook" element={<SupportHandBook />} />
          <Route path="sop" element={<SoP />} />
          <Route path="terms-and-conditions" element={<TermsConditions />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
